import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import clsx from "clsx";
import BuyNowTextBoxBackground, {
    IBuyNowTextBoxBackgroundProps,
} from "components/backgrounds/BuyNowTextBoxBackground";

const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        root: {
            padding: theme.spacing(3),
            color: theme.palette.common.white,
        },
    });
});

export type IBuyNowTextBoxClasses = Partial<ReturnType<typeof useStyles>>;

export interface IBuyNowTextBoxProps extends IBuyNowTextBoxBackgroundProps {
    classes?: IBuyNowTextBoxClasses;
}

export default function BuyNowTextBox(props: IBuyNowTextBoxProps) {
    const classes = useStyles();
    const { className, classes: overrideClasses, children, ...rest } = props;

    return (
        <BuyNowTextBoxBackground
            className={clsx(className, classes.root, overrideClasses?.root)}
            {...rest}
        >
            {children}
        </BuyNowTextBoxBackground>
    );
}
